
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $88bc78273956f61d$exports = {};

$parcel$export($88bc78273956f61d$exports, "focus-ring", function () { return $88bc78273956f61d$export$f39a09f249340e2a; }, function (v) { return $88bc78273956f61d$export$f39a09f249340e2a = v; });
$parcel$export($88bc78273956f61d$exports, "i18nFontFamily", function () { return $88bc78273956f61d$export$8c4ee2c50c22c514; }, function (v) { return $88bc78273956f61d$export$8c4ee2c50c22c514 = v; });
$parcel$export($88bc78273956f61d$exports, "spectrum-FocusRing-ring", function () { return $88bc78273956f61d$export$4109102f950813a6; }, function (v) { return $88bc78273956f61d$export$4109102f950813a6 = v; });
$parcel$export($88bc78273956f61d$exports, "spectrum-FocusRing", function () { return $88bc78273956f61d$export$24c7f46a6e3605dd; }, function (v) { return $88bc78273956f61d$export$24c7f46a6e3605dd = v; });
$parcel$export($88bc78273956f61d$exports, "spectrum-FocusRing--quiet", function () { return $88bc78273956f61d$export$2927016961429360; }, function (v) { return $88bc78273956f61d$export$2927016961429360 = v; });
$parcel$export($88bc78273956f61d$exports, "spectrum-Well", function () { return $88bc78273956f61d$export$98e76d3873e01aa9; }, function (v) { return $88bc78273956f61d$export$98e76d3873e01aa9 = v; });
var $88bc78273956f61d$export$f39a09f249340e2a;
var $88bc78273956f61d$export$8c4ee2c50c22c514;
var $88bc78273956f61d$export$4109102f950813a6;
var $88bc78273956f61d$export$24c7f46a6e3605dd;
var $88bc78273956f61d$export$2927016961429360;
var $88bc78273956f61d$export$98e76d3873e01aa9;
$88bc78273956f61d$export$f39a09f249340e2a = `LHIA7q_focus-ring`;
$88bc78273956f61d$export$8c4ee2c50c22c514 = `LHIA7q_i18nFontFamily`;
$88bc78273956f61d$export$4109102f950813a6 = `LHIA7q_spectrum-FocusRing-ring`;
$88bc78273956f61d$export$24c7f46a6e3605dd = `LHIA7q_spectrum-FocusRing ${$88bc78273956f61d$export$4109102f950813a6}`;
$88bc78273956f61d$export$2927016961429360 = `LHIA7q_spectrum-FocusRing--quiet`;
$88bc78273956f61d$export$98e76d3873e01aa9 = `LHIA7q_spectrum-Well`;


export {$88bc78273956f61d$exports as default};
//# sourceMappingURL=well_vars_css.mjs.map
